import { useContext, useSyncExternalStore } from 'react';
import { ReactReduxContext } from 'react-redux';
import type { RootState } from '../redux/createStore';
import type { SessionUser } from '../types/auth';

const noopSubscribe = () => () => {};

/**
 * Custom uploaded photo (jobForm) overrides OAuth `picture` / `image` everywhere we show the user avatar.
 *
 * Works without a Redux store too (the static pages' menu island mounts the menu with no store,
 * see web-static/pages/landing/menu-island/entry.tsx): the custom photo then simply isn't known
 * and the OAuth picture is used. `useAppSelector` would throw there, so this reads the store from
 * the (optional) context directly.
 */
export function useEffectiveUserProfilePhoto(user: SessionUser | null | undefined): string | null {
  const store = useContext(ReactReduxContext)?.store;
  const custom = useSyncExternalStore(
    store ? store.subscribe : noopSubscribe,
    () => (store ? ((store.getState() as RootState).jobForm?.profilePhotoDataUrl?.trim() ?? '') : ''),
    () => '',
  );
  if (custom) return custom;
  if (!user) return null;
  return user.image || user.picture || null;
}
